import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  USER_ORGANISATION_ITEM_CLEAR: 'USER_ORGANISATION_ITEM_CLEAR',
  USER_ORGANISATION_ITEM_SET: 'USER_ORGANISATION_ITEM_SET',

  USER_ORGANISATIONS_CLEAR: 'USER_ORGANISATIONS_CLEAR',

  USER_ORGANISATIONS_GET_FAILURE: 'USER_ORGANISATIONS_GET_FAILURE',
  USER_ORGANISATIONS_GET_REQUEST: 'USER_ORGANISATIONS_GET_REQUEST',
  USER_ORGANISATIONS_GET_SUCCESS: 'USER_ORGANISATIONS_GET_SUCCESS',
};

export const actionCreators = {
  clear: () => ({
    type: actionTypes.USER_ORGANISATIONS_CLEAR,
  }),

  getRequest: () => ({
    type: actionTypes.USER_ORGANISATIONS_GET_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.USER_ORGANISATIONS_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.USER_ORGANISATIONS_GET_FAILURE,
  }),
  getSuccess: (userOrganisations: Array<any>) => ({
    type: actionTypes.USER_ORGANISATIONS_GET_SUCCESS,
    payload: { userOrganisations },
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.USER_ORGANISATIONS_GET_FAILURE,
    error,
  }),

  itemClear: () => ({
    type: actionTypes.USER_ORGANISATION_ITEM_CLEAR,
  }),
  itemSet: (userOrganisation: any) => ({
    type: actionTypes.USER_ORGANISATION_ITEM_SET,
    payload: { userOrganisation },
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
